import authService from '../services/authService';

/**
 * 로그아웃 처리 함수
 * @param {Function} navigate - React Router의 navigate 함수
 * @param {Function} dispatch - Context dispatch 함수
 */
export const handleLogout = async (navigate, dispatch) => {
  try {
    // authService를 통한 로그아웃
    await authService.logout();
    
    // Context 상태 초기화
    if (dispatch) {
      dispatch({ type: 'LOGOUT' });
    }
    
    // 로그인 페이지로 이동
    if (navigate) {
      navigate('/', { replace: true });
    } else {
      window.location.href = '/';
    }
  } catch (error) {
    console.error('Logout error:', error);
    // 에러가 발생해도 로컬 데이터는 삭제하고 로그인 페이지로 이동
    authService.clearAuthData();
    window.location.href = '/';
  }
};